const {
  REACT_APP_DBS_API_URL_LOCAL,
  REACT_APP_DBS_API_URL_PUBLIC,
  REACT_APP_POSTHOG_LOCAL_KEY,
  REACT_APP_POSTHOG_PUBLIC_KEY,
  REACT_APP_SENTRY_LOCAL_DSN,
  REACT_APP_SENTRY_PUBLIC_DSN,
  REACT_APP_STRIPE_API_LOCAL_PUBLISHABLE_KEY,
  REACT_APP_STRIPE_API_PUBLIC_PUBLISHABLE_KEY,
} = process.env

const convertEmptyStringToUndefined = (value: string | undefined): string | undefined => {
  return value === '' ? undefined : value
}

const abbreviatedValue = (value: string | undefined): string => {
  if (!value) return 'DISABLED'
  return value.length > 13 ? value.slice(0, 13) + '...' : value
}

// Pick the correct API URLs based on the browser URL
export const isBrowserLocal = window.location.href.includes('//localhost')
console.log('[env] Is Browser Local:', isBrowserLocal)

// Backend API
export const REACT_APP_DBS_API_URL: string = (() => {
  if (isBrowserLocal) {
    if (!REACT_APP_DBS_API_URL_LOCAL) {
      throw new Error('Browser is local but REACT_APP_DBS_API_URL_LOCAL is not set in the environment variables')
    }
    return REACT_APP_DBS_API_URL_LOCAL
  } else {
    if (!REACT_APP_DBS_API_URL_PUBLIC) {
      throw new Error('Browser is not local but REACT_APP_DBS_API_URL_PUBLIC is not set in the environment variables')
    }
    return REACT_APP_DBS_API_URL_PUBLIC
  }
})()

console.log('[env] Using API URL:', REACT_APP_DBS_API_URL)

// PostHog API
export const REACT_APP_POSTHOG_KEY: string | undefined = isBrowserLocal
  ? convertEmptyStringToUndefined(REACT_APP_POSTHOG_LOCAL_KEY)
  : convertEmptyStringToUndefined(REACT_APP_POSTHOG_PUBLIC_KEY)

console.log('[env] Using PostHog Key:', abbreviatedValue(REACT_APP_POSTHOG_KEY))

// Sentry API
export const REACT_APP_SENTRY_DSN: string | undefined = isBrowserLocal
  ? convertEmptyStringToUndefined(REACT_APP_SENTRY_LOCAL_DSN)
  : convertEmptyStringToUndefined(REACT_APP_SENTRY_PUBLIC_DSN)

console.log('[env] Using Sentry DSN:', abbreviatedValue(REACT_APP_SENTRY_DSN))

// Stripe API

export const REACT_APP_STRIPE_API_PUBLISHABLE_KEY: string = (() => {
  if (isBrowserLocal) {
    if (!REACT_APP_STRIPE_API_LOCAL_PUBLISHABLE_KEY) {
      throw new Error('Browser is local but REACT_APP_STRIPE_API_LOCAL_PUBLISHABLE_KEY is not set in the environment variables')
    }
    return REACT_APP_STRIPE_API_LOCAL_PUBLISHABLE_KEY
  } else {
    if (!REACT_APP_STRIPE_API_PUBLIC_PUBLISHABLE_KEY) {
      throw new Error('Browser is not local but REACT_APP_STRIPE_API_PUBLIC_PUBLISHABLE_KEY is not set in the environment variables')
    }
    return REACT_APP_STRIPE_API_PUBLIC_PUBLISHABLE_KEY
  }
})()

console.log('[env] Using Stripe API Key starting:', abbreviatedValue(REACT_APP_STRIPE_API_PUBLISHABLE_KEY))
